import { startWatch } from '../../utils/lazy-load'

function goTop(toTop) {
	if (!toTop)
		return

	const handler = (target, isIntersecting) => isIntersecting ? toTop.classList.remove('active') : toTop.classList.add('active')
	startWatch([document.querySelector('.toTop-pixel')], handler, '35% 0% 0% 0%', 0, false)
}
goTop( document.querySelector('#to-top') )